module.exports = __webpack_public_path__ + "img/chinesecompany19.2142a093.png";